import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppModules } from '@common-modules/shared/app-modules.enum';
import { DialogService } from '@common-modules/shared/dialogs/dialogs.service';
import { SpinnerService } from '@common-modules/wlm-spinner/spinner.service';
import { finalize } from 'rxjs';
import { DashboardIdentity } from '../dashboard-identity';
import { DashboardsService } from '../dashboards.service';

const COMPONENT_SELECTOR = 'wlm-create-dashboard-popup';
@Component({
  selector: COMPONENT_SELECTOR,
  templateUrl: './create-dashboard-popup.component.html',
  styleUrl: './create-dashboard-popup.component.scss',
  standalone: false,
})
export class CreateDashboardPopupComponent {
  private setLoading: (loading: boolean) => void;
  dashboardModel: DashboardIdentity;
  isValid = false;
  readonly T_SCOPE = `${AppModules.RightPanel}.${COMPONENT_SELECTOR}`;
  readonly titleKey = `${this.T_SCOPE}.title`;

  constructor(
    private readonly _dialogRef: MatDialogRef<CreateDashboardPopupComponent>,
    @Inject(MAT_DIALOG_DATA) parameters,
    private readonly _dashboardsService: DashboardsService,
    private readonly _spinnerService: SpinnerService,
    private readonly _dialogService: DialogService
  ) {
    this.setLoading = this._spinnerService.buildSetLoadingFn();
  }

  onDashboardChange(dashboard: DashboardIdentity): void {
    this.dashboardModel = dashboard;
  }

  onValidChange(isValid: boolean): void {
    this.isValid = isValid;
  }

  onSubmit(): void {
    if (this.isValid) {
      this.setLoading(true);
      this._dashboardsService
        .createDashboard(this.dashboardModel)
        .pipe(finalize(() => this.setLoading(false)))
        .subscribe({
          next: (dashboard) => {
            this._dialogRef.close({ dashboard });
          },
          error: this._dialogService.showErrorMessage,
        });
    }
  }

  cancel(_) {
    this._dialogRef.close(false);
  }
}
